import { useEffect, useRef } from 'react';

const useStickyStack = (sectionCount) => {
  const sectionsRef = useRef([]);

  const registerSection = (index) => (el) => {
    sectionsRef.current[index] = el;
  };

  useEffect(() => {
    let rafPending = false;

    const doStack = () => {
      if (window.innerWidth <= 1080) return;

      const vh = window.innerHeight;
      const sections = sectionsRef.current;

      sections.forEach((sec, i) => {
        if (!sec) return;

        const wrapEl = sec.closest('.sections-wrap');
        if (!wrapEl) return;
        const wrapTop = wrapEl.getBoundingClientRect().top;
        const pos = wrapTop + i * vh;
        const b = -pos / vh;

        if (b > 0) {
          const capped = Math.min(1, b);
          sec.style.transform = `scale(${1 - capped * 0.06})`;
          sec.style.borderRadius = `${capped * 18}px`;
          sec.style.opacity = Math.max(0, 1 - b);
          sec.style.visibility = b >= 1 ? 'hidden' : 'visible';
        } else {
          sec.style.transform = '';
          sec.style.borderRadius = '';
          sec.style.opacity = '';
          sec.style.visibility = '';
        }
      });

      rafPending = false;
    };

    const scheduleStack = () => {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(doStack);
      }
    };

    const resetStyles = () => {
      sectionsRef.current.forEach((sec) => {
        if (!sec) return;
        sec.style.transform = '';
        sec.style.borderRadius = '';
        sec.style.opacity = '';
        sec.style.visibility = '';
      });
    };

    const mq = window.matchMedia('(min-width: 1081px)');

    const handleBreakpoint = (e) => {
      if (e.matches) {
        window.addEventListener('scroll', scheduleStack, { passive: true });
        doStack();
      } else {
        window.removeEventListener('scroll', scheduleStack);
        resetStyles();
      }
    };

    handleBreakpoint(mq);
    mq.addEventListener('change', handleBreakpoint);

    return () => {
      mq.removeEventListener('change', handleBreakpoint);
      window.removeEventListener('scroll', scheduleStack);
    };
  }, [sectionCount]);

  return { registerSection };
};

export default useStickyStack;
